<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-between align-items-center mb-3"
        >

          <div>

            <b-button
              variant="warning"
              class="mr-1"
              @click="$router.push({ name: 'geodesia-vrs-coordinates-map' })"
            >
              <feather-icon
                icon="MapIcon"
                size="14"
                class="mr-1"
              />
              خريطة إحداثيات VRS
            </b-button>
            <b-button
              variant="primary"
              class="mr-1"
              @click="$router.push({ name: 'geodesia-lab' })"
            >
              <feather-icon
                icon="MapIcon"
                size="14"
                class="mr-1"
              />
              Geodesia Lab
            </b-button>
            <!-- <b-button
              variant="secondary"
              class="mr-2"
              @click="showJxlStorageModal = true"
            >
              <feather-icon icon="FolderIcon" size="14" class="mr-1"></feather-icon>
              ملفات JXL من التخزين
            </b-button> -->
            <b-button
              variant="success"
              class="mr-1"
              @click="showJxlImportModal = true"
            >
              <feather-icon
                icon="UploadIcon"
                size="14"
                class="mr-1"
              />
              استيراد ملف JXL
            </b-button>
            <b-button
              variant="outline-danger"
              class="mr-1"
              @click="showDeleteJxlModal = true"
            >
              <feather-icon
                icon="Trash2Icon"
                size="14"
                class="mr-1"
              />
              حذف ملف JXL
            </b-button>
            <b-button
              variant="info"
              class="mr-1"
              @click="showKmzImportModal = true"
            >
              <feather-icon
                icon="UploadIcon"
                size="14"
                class="mr-1"
              />
              استيراد ملف KMZ/KML
            </b-button>
            <b-button
              variant="outline-success"
              class="mr-1"
              @click="showGeodesiaSheetImportModal = true"
            >
              <feather-icon
                icon="UploadIcon"
                size="14"
                class="mr-1"
              />
              استيراد Excel Trimble / Geodesia
            </b-button>
            <b-button
              variant="warning"
              class="mr-1"
              @click="showRawImportModal = true"
            >
              <feather-icon
                icon="UploadIcon"
                size="14"
                class="mr-1"
              />
              استيراد ملف RAW/RW5 و تحويله إلى JXL
            </b-button>
            <b-button
              variant="info"
              class="mr-1"
              @click="$router.push({ name: 'geodesia-rw5-files' })"
            >
              <feather-icon
                icon="FileIcon"
                size="14"
                class="mr-1"
              />
              ملفات RW5
            </b-button>
            <b-button
              variant="success"
              class="mr-1"
              @click="showDownloadModal = true"
            >
              <feather-icon
                icon="DownloadIcon"
                size="14"
                class="mr-1"
              />
              تحميل ملفات المشاريع مع الإحداثيات
            </b-button>
            <b-button
              v-if="hasPermission('generate jxlFiles')"
              variant="outline-secondary"
              class="mr-1"
              v-b-tooltip.hover
              :title="bulkLocationJxlTooltip"
              :disabled="downloadingBulkLocationJxl"
              @click="downloadBulkLocationCoordinatesJxl"
            >
              <b-spinner
                v-if="downloadingBulkLocationJxl"
                small
                class="mr-1"
              />
              <feather-icon
                v-else
                icon="DownloadIcon"
                size="14"
                class="mr-1"
              />
              {{ downloadingBulkLocationJxl ? 'جاري إنشاء الأرشيف...' : 'تنزيل JXL مجمع (إحداثيات المواقع)' }}
            </b-button>
            <b-button
              v-if="hasPermission('generate jxlFiles')"
              variant="primary"
              class="mr-1"
              @click="showLocationSurveyExportModal = true"
            >
              <feather-icon
                icon="DownloadIcon"
                size="14"
                class="mr-1"
              />
              تصدير ملفات الرفع المساحي
            </b-button>
            <!-- <b-button
              variant="dark"
              class="mr-1"
              @click="showAssignJxlModal = true"
            >
              <feather-icon icon="LinkIcon" size="14" class="mr-1"></feather-icon>
              ربط ملف JXL بمشروع
            </b-button> -->
            <!-- <b-button
              variant="primary"
              @click="downloadFiles"
              :disabled="selectedProjects.length === 0 || downloading"
            >
              <feather-icon icon="DownloadIcon" size="14" class="mr-1"></feather-icon>
              {{ downloading ? 'جاري التحميل...' : `تحميل الملفات (${selectedProjects.length})` }}
            </b-button> -->
          </div>
        </b-col>

        <!-- Filters -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filters.search"
            placeholder="بحث بالكود أو الاسم أو المالك"
            @input="handleSearch"
          />
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filters.surveying_code"
            placeholder="كود الرفع المساحي"
            @input="handleFilterChange"
          />
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filters.owner_name"
            placeholder="اسم المالك"
            @input="handleFilterChange"
          />
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.governorate_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="governorates || []"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar"
            placeholder="المحافظة"
            @search="onGovernorateSearch"
            @input="handleFilterChange"
          >
            <template #option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
            <template #selected-option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.center_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="centers || []"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar"
            placeholder="الجهاز / الحي / المركز"
            @search="onCenterSearch"
            @input="handleFilterChange"
          >
            <template #option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
            <template #selected-option="{ name_ar }">
              <span>{{ name_ar }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.check_status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="checkStatusOptions"
            :reduce="(val) => val.value"
            placeholder="حالة المراجعة"
            label="label"
            @input="handleFilterChange"
          >
            <template #option="{ label }">
              <span>{{ label }}</span>
            </template>
            <template #selected-option="{ label }">
              <span>{{ label }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.survey_status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="surveyStatusOptions"
            :reduce="(val) => val.value"
            placeholder="حالة الرفع المساحي"
            label="label"
            @input="handleFilterChange"
          >
            <template #option="{ label }">
              <span>{{ label }}</span>
            </template>
            <template #selected-option="{ label }">
              <span>{{ label }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.file_extension"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="fileExtensionOptions"
            :reduce="(val) => val.value"
            placeholder="نوع الملف"
            label="label"
            @input="handleFilterChange"
          >
            <template #option="{ label }">
              <span>{{ label }}</span>
            </template>
            <template #selected-option="{ label }">
              <span>{{ label }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.sort_by"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="sortByOptions"
            :reduce="(val) => val.value"
            placeholder="ترتيب حسب"
            label="label"
            @input="handleFilterChange"
          >
            <template #option="{ label }">
              <span>{{ label }}</span>
            </template>
            <template #selected-option="{ label }">
              <span>{{ label }}</span>
            </template>
          </v-select>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filters.sort_order"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="sortOrderOptions"
            :reduce="(val) => val.value"
            placeholder="الاتجاه"
            label="label"
            @input="handleFilterChange"
          >
            <template #option="{ label }">
              <span>{{ label }}</span>
            </template>
            <template #selected-option="{ label }">
              <span>{{ label }}</span>
            </template>
          </v-select>
        </b-col>
      </b-row>
    </b-card>

    <!-- Table -->
    <b-card class="mt-1">
      <b-spinner
        v-if="loading"
        class="d-block text-center my-4"
      />
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <b-table
        v-else
        ref="table"
        :items="projects"
        :fields="fields"
        responsive
        striped
        hover
        :per-page="pagination && pagination.per_page ? pagination.per_page : 15"
        :current-page="pagination && pagination.current_page ? pagination.current_page : 1"
        selectable
        select-mode="multi"
        @row-selected="onRowSelected"
      >
        <template #head(selected)>
          <b-form-checkbox
            :checked="allSelected"
            :indeterminate="indeterminate"
            @change="toggleSelectAll"
          />
        </template>
        <template #cell(selected)="{ rowSelected }">
          <b-form-checkbox
            :checked="rowSelected"
            @change="() => {}"
          />
        </template>

        <template #cell(survey_coding)="row">
          <strong>{{ row.item.survey_coding }}</strong>
        </template>

        <template #cell(owners)="row">
          <div v-if="row.item.owners && row.item.owners.length > 0">
            <span
              v-for="(owner, index) in row.item.owners"
              :key="index"
            >
              {{ owner.name }}<span v-if="index < row.item.owners.length - 1">، </span>
            </span>
          </div>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>

        <template #cell(governorate)="row">
          {{ row.item.governorate && row.item.governorate.name ? row.item.governorate.name : '-' }}
        </template>

        <template #cell(center)="row">
          {{ row.item.center && row.item.center.name ? row.item.center.name : '-' }}
        </template>

        <template #cell(check_status)="row">
          <b-badge
            v-if="row.item.landsurveyorder && row.item.landsurveyorder.check_status"
            :variant="getCheckStatusVariant(row.item.landsurveyorder.check_status)"
          >
            {{ getCheckStatusLabel(row.item.landsurveyorder.check_status) }}
          </b-badge>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>

        <template #cell(survey_status)="row">
          <b-badge
            v-if="row.item.landsurveyorder && row.item.landsurveyorder.survey_status"
            :variant="getSurveyStatusVariant(row.item.landsurveyorder.survey_status)"
          >
            {{ getSurveyStatusLabel(row.item.landsurveyorder.survey_status) }}
          </b-badge>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>

        <template #cell(file_extension)="row">
          <b-badge
            v-if="row.item.file_extension && row.item.file_extension !== 'none'"
            variant="success"
          >
            {{ row.item.file_extension }}
          </b-badge>
          <b-badge
            v-else
            variant="secondary"
          >
            لا يوجد ملف
          </b-badge>
        </template>
      </b-table>

      <!-- Pagination -->
      <b-pagination
        v-if="pagination && pagination.last_page > 1"
        v-model="filters.page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        align="center"
        class="mt-3"
        @change="onPageChange"
      />
    </b-card>

    <!-- JXL Import Modal -->
    <b-modal
      v-model="showJxlImportModal"
      title="استيراد ملف JXL"
      size="lg"
      :ok-disabled="!jxlFile || importingJxl"
      :ok-title="importingJxl ? 'جاري الاستيراد...' : 'استيراد'"
      cancel-title="إلغاء"
      no-close-on-backdrop
      @ok.prevent="handleJxlImport"
      @hidden="resetJxlImport"
    >
      <b-form-group label="اختر ملف JXL">
        <b-form-file
          v-model="jxlFile"
          accept=".jxl"
          placeholder="اختر ملف أو اسحب الملف هنا"
          drop-placeholder="اسحب الملف هنا"
          @change="onJxlFileChange"
        />
        <small class="text-muted">يدعم الملفات: .jxl</small>
      </b-form-group>

      <!-- <b-form-group label="معرف المشروع (اختياري)" class="mt-3">
        <b-form-input
          v-model.number="jxlProjectId"
          type="number"
          placeholder="أدخل معرف المشروع"
        />
        <small class="text-muted">إذا تم تحديد معرف المشروع، سيتم ربط الملف تلقائياً بالمشروع</small>
      </b-form-group> -->

      <!-- Loader -->
      <div
        v-if="importingJxl"
        class="text-center my-4"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted">
          جاري استيراد الملف...
        </p>
      </div>

      <b-alert
        v-if="jxlImportError"
        variant="danger"
        show
        class="mt-3"
      >
        {{ jxlImportError }}
      </b-alert>

      <div
        v-if="jxlImportResult"
        class="mt-3"
      >
        <b-alert
          variant="success"
          show
        >
          <h5>تم الاستيراد بنجاح!</h5>
          <p><strong>اسم الملف:</strong> {{ jxlImportResult.file_name }}</p>
          <p><strong>معرف JXL:</strong> {{ jxlImportResult.jxl_id }}</p>
          <p><strong>معرف الملف:</strong> {{ jxlImportResult.media_id }}</p>
          <p v-if="jxlImportResult.project_id">
            <strong>معرف المشروع:</strong> {{ jxlImportResult.project_id }}
          </p>
          <p><strong>عدد النقاط المستخرجة:</strong> {{ jxlImportResult.parsed_points_count }}</p>
          <p><strong>عدد النقاط المحفوظة:</strong> {{ jxlImportResult.stored_points_count }}</p>
          <p
            v-if="jxlImportResult.skipped_duplicates_count > 0"
            class="text-info"
          >
            <strong>عدد النقاط المكررة المتجاهلة:</strong> {{ jxlImportResult.skipped_duplicates_count }}
          </p>
          <p
            v-if="jxlImportResult.errors_count > 0"
            class="text-warning"
          >
            <strong>عدد الأخطاء:</strong> {{ jxlImportResult.errors_count }}
          </p>
        </b-alert>

        <div
          v-if="jxlImportResult.errors && jxlImportResult.errors.length > 0"
          class="mt-3"
        >
          <h6>الأخطاء:</h6>
          <ul>
            <li
              v-for="(error, index) in jxlImportResult.errors"
              :key="index"
            >
              {{ error }}
            </li>
          </ul>
        </div>

        <div
          v-if="jxlImportResult.skipped_duplicates && jxlImportResult.skipped_duplicates.length > 0"
          class="mt-3"
        >
          <h6>النقاط المكررة المتجاهلة:</h6>
          <ul>
            <li
              v-for="(dup, index) in jxlImportResult.skipped_duplicates"
              :key="index"
            >
              {{ dup.point_name || `Point ${dup.id}` }}: {{ dup.latitude }}, {{ dup.longitude }}
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <!-- Delete JXL file by coordinate id -->
    <b-modal
      v-model="showDeleteJxlModal"
      title="حذف ملف JXL"
      size="md"
      ok-variant="danger"
      :ok-disabled="deletingJxlFile || !isPositiveInt(deleteJxlCoordinateId)"
      :ok-title="deletingJxlFile ? 'جاري الحذف...' : 'حذف'"
      cancel-title="إلغاء"
      no-close-on-backdrop
      @ok.prevent="handleDeleteJxlFile"
      @hidden="resetDeleteJxlModal"
    >
      <b-form-group
        label="معرف إحداثي JXL *"
        class="mb-0"
      >
        <b-form-input
          v-model.number="deleteJxlCoordinateId"
          type="number"
          min="1"
          placeholder="أدخل jxl_coordinate_id"
        />
        <small class="text-muted">يتم حذف ملف JXL المرتبط بهذا الإحداثي حسب إعدادات الخادم</small>
      </b-form-group>

      <div
        v-if="deletingJxlFile"
        class="text-center my-3"
      >
        <b-spinner small />
        <span class="ml-2 text-muted">جاري الحذف...</span>
      </div>

      <b-alert
        v-if="deleteJxlError"
        variant="danger"
        show
        class="mt-3 mb-0"
      >
        {{ deleteJxlError }}
      </b-alert>
    </b-modal>

    <!-- KMZ Import Modal -->
    <b-modal
      v-model="showKmzImportModal"
      title="استيراد ملف KMZ/KML"
      size="lg"
      :ok-disabled="!kmzFile || importingKmz"
      ok-title="استيراد"
      cancel-title="إلغاء"
      @ok="handleKmzImport"
      @hidden="resetKmzImport"
    >
      <b-form-group label="اختر ملف KMZ أو KML">
        <b-form-file
          v-model="kmzFile"
          accept=".kmz,.kml"
          placeholder="اختر ملف أو اسحب الملف هنا"
          drop-placeholder="اسحب الملف هنا"
          @change="onKmzFileChange"
        />
        <small class="text-muted">يدعم الملفات: .kmz, .kml</small>
      </b-form-group>

      <b-alert
        v-if="kmzImportError"
        variant="danger"
        show
        class="mt-3"
      >
        {{ kmzImportError }}
      </b-alert>

      <div
        v-if="kmzImportResult"
        class="mt-3"
      >
        <b-alert
          variant="success"
          show
        >
          <h5>تم الاستيراد بنجاح!</h5>
          <p><strong>اسم الملف:</strong> {{ kmzImportResult.file_name }}</p>
          <p><strong>عدد النقاط المستخرجة:</strong> {{ kmzImportResult.parsed_points_count }}</p>
          <p><strong>عدد النقاط المحفوظة:</strong> {{ kmzImportResult.stored_points_count }}</p>
          <p
            v-if="kmzImportResult.errors_count > 0"
            class="text-warning"
          >
            <strong>عدد الأخطاء:</strong> {{ kmzImportResult.errors_count }}
          </p>
        </b-alert>

        <div
          v-if="kmzImportResult.errors && kmzImportResult.errors.length > 0"
          class="mt-3"
        >
          <h6>الأخطاء:</h6>
          <ul>
            <li
              v-for="(error, index) in kmzImportResult.errors"
              :key="index"
            >
              النقطة {{ error.point_name || error.point_index }}: {{ error.error }}
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <!-- Geodesia / Trimble Excel sheet import -->
    <b-modal
      v-model="showGeodesiaSheetImportModal"
      title="استيراد جدول Geodesia / Trimble (Excel)"
      size="xl"
      scrollable
      hide-footer
      @hidden="resetGeodesiaSheetImport"
    >
      <p class="text-muted small mb-2">
        ملف .xlsx أو .xls بتنسيق تصدير Trimble Business Center. يُرسل كـ multipart/form-data (حقل
        <code>geodesia_sheet_file</code>).
      </p>
      <b-form-group label="معرف المشروع (اختياري)">
        <b-form-input
          v-model.number="geodesiaSheetProjectId"
          type="number"
          min="1"
          placeholder="لربط الملف بالمشروع — كاستيراد KML/DXF"
          :disabled="importingGeodesiaSheet"
        />
        <small class="text-muted">اتركه فارغاً لاستيراد عام دون ربط بمشروع.</small>
      </b-form-group>
      <b-form-group label="اختر ملف Excel">
        <b-form-file
          v-model="geodesiaSheetFile"
          accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          placeholder="اختر ملف .xlsx أو .xls"
          drop-placeholder="اسحب الملف هنا"
          :disabled="importingGeodesiaSheet"
          @input="onGeodesiaSheetFileInput"
        />
        <small class="text-muted">الصيغ المدعومة: .xlsx و .xls فقط</small>
      </b-form-group>

      <div
        v-if="importingGeodesiaSheet"
        class="text-center my-3"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted mb-0">
          جاري رفع الملف ومعالجته...
        </p>
      </div>

      <b-alert
        v-if="geodesiaSheetImportError"
        variant="danger"
        show
        class="mt-2 mb-0"
      >
        {{ geodesiaSheetImportError }}
      </b-alert>

      <div
        v-if="geodesiaSheetImportResult"
        class="mt-3"
      >
        <b-alert
          :variant="Number(geodesiaSheetImportResult.errors_count || 0) > 0 ? 'warning' : 'success'"
          show
        >
          <p class="mb-1">
            <strong>اسم الملف:</strong> {{ geodesiaSheetImportResult.file_name }}
          </p>
          <p
            v-if="geodesiaSheetImportResult.file_updated"
            class="mb-1 text-info small"
          >
            تم استبدال ملف سابق بنفس الاسم.
          </p>
          <p class="mb-1">
            <strong>مقروءة:</strong> {{ geodesiaSheetImportResult.parsed_points_count }}
            — <strong>محفوظة:</strong> {{ geodesiaSheetImportResult.stored_points_count }}
            <span v-if="Number(geodesiaSheetImportResult.errors_count || 0) > 0">
              — <strong>أخطاء:</strong> {{ geodesiaSheetImportResult.errors_count }}
            </span>
          </p>
          <p
            v-if="geodesiaSheetImportResult.project_id"
            class="mb-1 small"
          >
            <strong>المشروع:</strong> {{ geodesiaSheetImportResult.project_id }}
          </p>
          <p
            v-if="geodesiaSheetImportResult.geodesia_sheet_file_id != null"
            class="mb-0 small"
          >
            <strong>معرف السجل:</strong> {{ geodesiaSheetImportResult.geodesia_sheet_file_id }}
            <span v-if="geodesiaSheetImportResult.media_id != null"> | <strong>media:</strong> {{ geodesiaSheetImportResult.media_id }}</span>
          </p>
        </b-alert>

        <div
          v-if="geodesiaSheetImportResult.errors && geodesiaSheetImportResult.errors.length"
          class="mt-2"
        >
          <h6 class="text-warning mb-1">
            أخطاء النقاط
          </h6>
          <ul class="small pl-3 mb-0">
            <li
              v-for="(rowErr, idx) in geodesiaSheetImportResult.errors"
              :key="'geodesia-sheet-err-' + idx"
            >
              {{ formatGeodesiaSheetPointError(rowErr) }}
            </li>
          </ul>
        </div>

        <h6 class="mt-3 mb-1">
          النقاط المحفوظة
        </h6>
        <div
          v-if="geodesiaSheetTableRows.length"
          class="geodesia-sheet-import-table-wrap border rounded"
        >
          <b-table
            :items="geodesiaSheetTableRows"
            :fields="geodesiaSheetTableFields"
            small
            striped
            hover
            responsive
            class="mb-0"
          />
        </div>
        <p
          v-else
          class="text-muted small"
        >
          لا توجد صفوف إحداثيات في الاستجابة.
        </p>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="importingGeodesiaSheet"
          @click="showGeodesiaSheetImportModal = false"
        >
          إغلاق
        </b-button>
        <b-button
          variant="primary"
          :disabled="!geodesiaSheetFile || importingGeodesiaSheet"
          @click="submitGeodesiaSheetImport"
        >
          <b-spinner
            v-if="importingGeodesiaSheet"
            small
            class="mr-50"
          />
          استيراد
        </b-button>
      </div>
    </b-modal>

    <!-- RAW/RW5 Import Modal -->
    <b-modal
      v-model="showRawImportModal"
      title="استيراد ملف RAW/RW5 و تحويله إلى JXL"
      size="lg"
      :ok-disabled="!rawFile || importingRaw"
      :ok-title="importingRaw ? 'جاري الاستيراد...' : 'استيراد'"
      cancel-title="إلغاء"
      no-close-on-backdrop
      @ok.prevent="handleRawImport"
      @hidden="resetRawImport"
    >
      <b-form-group label="اختر ملف RAW أو RW5">
        <b-form-file
          v-model="rawFile"
          accept=".raw,.rw5"
          placeholder="اختر ملف أو اسحب الملف هنا"
          drop-placeholder="اسحب الملف هنا"
          @change="onRawFileChange"
        />
        <small class="text-muted">يدعم الملفات: .raw, .rw5</small>
      </b-form-group>

      <!-- Loader -->
      <div
        v-if="importingRaw"
        class="text-center my-4"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted">
          جاري استيراد وتحويل الملف...
        </p>
      </div>

      <b-alert
        v-if="rawImportError"
        variant="danger"
        show
        class="mt-3"
      >
        {{ rawImportError }}
      </b-alert>

      <div
        v-if="rawImportResult"
        class="mt-3"
      >
        <b-alert
          variant="success"
          show
        >
          <h5>تم الاستيراد والتحويل بنجاح!</h5>
          <p><strong>اسم الملف المحول:</strong> {{ rawImportResult.file_name }}</p>
          <p><strong>اسم الملف الأصلي:</strong> {{ rawImportResult.original_file_name }}</p>
          <p><strong>معرف ملف JXL:</strong> {{ rawImportResult.jxl_file_id }}</p>
          <p><strong>عدد النقاط:</strong> {{ rawImportResult.points_count }}</p>
          <div
            v-if="rawImportResult.point_names && rawImportResult.point_names.length > 0"
            class="mt-2"
          >
            <p><strong>أسماء النقاط:</strong></p>
            <ul>
              <li
                v-for="(pointName, index) in rawImportResult.point_names"
                :key="index"
              >
                {{ pointName }}
              </li>
            </ul>
          </div>
        </b-alert>
      </div>
    </b-modal>

    <!-- Download Projects Files Modal -->
    <b-modal
      v-model="showDownloadModal"
      title="تحميل ملفات المشاريع مع الإحداثيات"
      size="lg"
      :ok-disabled="downloadingFiles || !downloadParams.file_extension"
      :ok-title="downloadingFiles ? 'جاري التحميل...' : 'تحميل'"
      cancel-title="إلغاء"
      @ok.prevent="handleDownloadFiles"
      @hidden="resetDownloadModal"
      no-close-on-backdrop
    >
      <b-row>
        <b-col
          cols="12"
          md="6"
        >

          <b-form-group
            label="نوع الملف *"
            class="mb-3"
          >
            <v-select
              v-model="downloadParams.file_extension"
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              :options="downloadFileExtensionOptions"
              :reduce="(val) => val.value"
              placeholder="اختر نوع الملف"
              label="label"
            >
              <template #option="{ label }">
                <span>{{ label }}</span>
              </template>
              <template #selected-option="{ label }">
                <span>{{ label }}</span>
              </template>
            </v-select>
            <small class="text-muted">اختر نوع الملف المراد تحميله (.jxl أو .rw5)</small>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >

          <b-form-group
            label="حالة المشروع"
            class="mb-3"
          >
            <v-select
              v-model="downloadParams.project_status"
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              :options="downloadProjectStatusOptions"
              :reduce="(val) => val.value"
              placeholder="جميع الحالات"
              label="label"
              :clearable="true"
            >
              <template #option="{ label }">
                <span>{{ label }}</span>
              </template>
              <template #selected-option="{ label }">
                <span>{{ label }}</span>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >

          <b-form-group
            label="المحافظة"
            class="mb-3"
          >
            <v-select
              v-model="downloadParams.governorate_id"
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              :options="governorates || []"
              :reduce="val => val.id"
              :get-option-label="option => option.name_ar"
              placeholder="جميع المحافظات"
              :clearable="true"
              @search="onGovernorateSearch"
            >
              <template #option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
              <template #selected-option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >

          <b-form-group
            label="الجهاز / الحي / المركز"
            class="mb-3"
          >
            <v-select
              v-model="downloadParams.center_id"
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              :options="centers || []"
              :reduce="val => val.id"
              :get-option-label="option => option.name_ar"
              placeholder="جميع المراكز"
              :clearable="true"
              @search="onCenterSearch"
              :disabled="!downloadParams.governorate_id"
            >
              <template #option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
              <template #selected-option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="طريقة الرفع المساحي"
            class="mb-3"
          >
            <v-select
              v-model="downloadParams.survey_method_id"
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              :options="surveyMethods"
              :reduce="val => val.id"
              :get-option-label="option => option.name"
              placeholder="جميع طرق الرفع"
              :clearable="true"
              :loading="loadingSurveyMethods"
              @open="fetchSurveyMethods"
            >
              <template #option="{ name }">
                <span>{{ name }}</span>
              </template>
              <template #selected-option="{ name }">
                <span>{{ name }}</span>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Loader -->
      <div
        v-if="downloadingFiles"
        class="text-center my-4"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted">
          جاري تحميل الملفات...
        </p>
        <small class="text-muted">قد يستغرق التحميل بعض الوقت حسب حجم الملفات</small>
      </div>

      <b-alert
        v-if="downloadError"
        variant="danger"
        show
        class="mt-3"
      >
        {{ downloadError }}
      </b-alert>
    </b-modal>

    <!-- Location Survey Exports Modal (JXL / HTML from RW5/RAW + location coordinates) -->
    <b-modal
      v-model="showLocationSurveyExportModal"
      title="تصدير ملفات الرفع المساحي"
      size="lg"
      :ok-disabled="exportingLocationSurvey || !locationSurveyExportParams.format"
      :ok-title="exportingLocationSurvey ? 'جاري التصدير...' : 'تصدير ملفات الرفع المساحي'"
      cancel-title="إلغاء"
      @ok.prevent="exportLocationSurveyFiles"
      @hidden="resetLocationSurveyExportModal"
      no-close-on-backdrop
    >
      <p class="text-muted small mb-3">
        يتم إنشاء الإحداثيات من قطع الأراضي المسجلة في المشروع، بينما تُؤخذ بيانات الرفع (الثابتة، الأوقات، الدقة، الأقمار الصناعية) من ملف RW5 أو RAW المرفق بنفس المشروع.
      </p>

      <b-form-group
        label="صيغة التصدير *"
        class="mb-3"
      >
        <b-form-radio-group
          v-model="locationSurveyExportParams.format"
          :options="locationSurveyExportFormatOptions"
          stacked
        />
        <small
          v-if="locationSurveyExportErrors.format"
          class="text-danger d-block mt-1"
        >
          {{ locationSurveyExportErrors.format }}
        </small>
      </b-form-group>

      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="المحافظة"
            class="mb-3"
          >
            <v-select
              v-model="locationSurveyExportParams.governorate_id"
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              :options="governorates || []"
              :reduce="val => val.id"
              :get-option-label="option => option.name_ar"
              placeholder="جميع المحافظات"
              :clearable="true"
              @search="onGovernorateSearch"
            >
              <template #option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
              <template #selected-option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
            </v-select>
            <small
              v-if="locationSurveyExportErrors.governorate_id"
              class="text-danger d-block mt-1"
            >
              {{ locationSurveyExportErrors.governorate_id }}
            </small>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="المركز"
            class="mb-3"
          >
            <v-select
              v-model="locationSurveyExportParams.center_id"
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              :options="centers || []"
              :reduce="val => val.id"
              :get-option-label="option => option.name_ar"
              placeholder="جميع المراكز"
              :clearable="true"
              :disabled="!locationSurveyExportParams.governorate_id"
              @search="onCenterSearch"
            >
              <template #option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
              <template #selected-option="{ name_ar }">
                <span>{{ name_ar }}</span>
              </template>
            </v-select>
            <small
              v-if="locationSurveyExportErrors.center_id"
              class="text-danger d-block mt-1"
            >
              {{ locationSurveyExportErrors.center_id }}
            </small>
          </b-form-group>
        </b-col>
      </b-row>

      <div
        v-if="exportingLocationSurvey"
        class="text-center my-3"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted mb-0">
          جاري إنشاء أرشيف التصدير...
        </p>
      </div>

      <b-alert
        v-if="locationSurveyExportError"
        variant="danger"
        show
        class="mt-2 mb-0"
      >
        {{ locationSurveyExportError }}
      </b-alert>
    </b-modal>

    <!-- JXL Storage Files Modal -->
    <b-modal
      v-model="showJxlStorageModal"
      title="ملفات JXL من التخزين"
      size="xl"
      ok-title="معالجة الملفات"
      cancel-title="إغلاق"
      :ok-disabled="processingJxlFiles || !storageFiles.length"
      @ok.prevent="handleProcessJxlFiles"
      @hidden="resetJxlStorage"
    >
      <b-form-group
        label="مسار المجلد"
        class="mb-3"
      >
        <b-form-input
          v-model="storageDirectory"
          placeholder="مثال: geodesia/jxl_files/2026/03"
        />
        <small class="text-muted">اتركه فارغاً لاستخدام المسار الافتراضي</small>
      </b-form-group>

      <b-button
        variant="primary"
        class="mb-3"
        :disabled="loadingStorageFiles"
        @click="fetchStorageFiles"
      >
        <b-spinner
          v-if="loadingStorageFiles"
          small
          class="mr-1"
        />
        {{ loadingStorageFiles ? 'جاري التحميل...' : 'عرض الملفات' }}
      </b-button>

      <b-alert
        v-if="storageError"
        variant="danger"
        show
      >
        {{ storageError }}
      </b-alert>

      <div
        v-if="storageFiles.length > 0"
        class="mt-3"
      >
        <h6>عدد الملفات: {{ storageFiles.length }}</h6>
        <b-table
          :items="storageFiles"
          :fields="storageFilesFields"
          responsive
          striped
          hover
          class="mt-2"
        >
          <template #cell(file_name)="row">
            <strong>{{ row.item.file_name }}</strong>
          </template>
          <template #cell(size)="row">
            {{ formatFileSize(row.item.size) }}
          </template>
          <template #cell(last_modified)="row">
            {{ formatDate(row.item.last_modified) }}
          </template>
        </b-table>
      </div>

      <div
        v-if="processingResult"
        class="mt-3"
      >
        <b-alert
          variant="success"
          show
        >
          <h6>نتائج المعالجة:</h6>
          <p><strong>عدد الملفات المعالجة:</strong> {{ processingResult.processed_files_count }}</p>
          <p><strong>عدد الملفات الفاشلة:</strong> {{ processingResult.failed_files_count }}</p>
          <p><strong>إجمالي الإحداثيات المحفوظة:</strong> {{ processingResult.total_coordinates_stored }}</p>
        </b-alert>

        <div
          v-if="processingResult.processed_files && processingResult.processed_files.length > 0"
          class="mt-3"
        >
          <h6>الملفات المعالجة:</h6>
          <ul>
            <li
              v-for="(file, index) in processingResult.processed_files"
              :key="index"
            >
              {{ file.file_name }} - {{ file.stored_points_count }} نقطة
            </li>
          </ul>
        </div>

        <div
          v-if="processingResult.failed_files && processingResult.failed_files.length > 0"
          class="mt-3"
        >
          <h6 class="text-danger">
            الملفات الفاشلة:
          </h6>
          <ul>
            <li
              v-for="(file, index) in processingResult.failed_files"
              :key="index"
            >
              {{ file.file_name }} - {{ file.reason }}
            </li>
          </ul>
        </div>
      </div>

      <div
        v-if="processingJxlFiles"
        class="text-center my-4"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted">
          جاري معالجة الملفات...
        </p>
      </div>
    </b-modal>

    <!-- Assign JXL to Project Modal -->
    <b-modal
      v-model="showAssignJxlModal"
      title="ربط ملف JXL بمشروع"
      size="lg"
      ok-title="ربط"
      cancel-title="إلغاء"
      :ok-disabled="!assignSurveyCoding || !assignJxlCoordinateId || assigningJxl"
      @ok.prevent="handleAssignJxl"
      @hidden="resetAssignJxl"
    >
      <b-form-group
        label="كود الرفع المساحي للمشروع"
        class="mb-3"
      >
        <b-form-input
          v-model="assignSurveyCoding"
          placeholder="أدخل كود الرفع المساحي"
        />
      </b-form-group>

      <!-- <b-form-group label="معرف ملف JXL" class="mb-3">
        <b-form-input
          v-model.number="assignJxlFileId"
          type="number"
          placeholder="أدخل معرف ملف JXL"
        />
        <small class="text-muted">أو استخدم معرف الإحداثي أدناه</small>
      </b-form-group> -->

      <b-form-group
        label="معرف إحداثي JXL (بديل)"
        class="mb-3"
      >
        <b-form-input
          v-model.number="assignJxlCoordinateId"
          type="number"
          placeholder="أدخل معرف إحداثي JXL"
        />
        <small class="text-muted">استخدم إما معرف الملف أو معرف الإحداثي</small>
      </b-form-group>

      <b-alert
        v-if="assignJxlError"
        variant="danger"
        show
      >
        {{ assignJxlError }}
      </b-alert>

      <div
        v-if="assignJxlResult"
        class="mt-3"
      >
        <b-alert
          variant="success"
          show
        >
          <h6>تم الربط بنجاح!</h6>
          <p><strong>اسم المشروع:</strong> {{ assignJxlResult.project_name }}</p>
          <p><strong>كود الرفع المساحي:</strong> {{ assignJxlResult.survey_coding }}</p>
          <p><strong>اسم الملف الأصلي:</strong> {{ assignJxlResult.original_file_name }}</p>
          <p><strong>اسم الملف المعروض:</strong> {{ assignJxlResult.display_file_name }}</p>
          <p><strong>معرف الملف:</strong> {{ assignJxlResult.media_id }}</p>
        </b-alert>
      </div>

      <div
        v-if="assigningJxl"
        class="text-center my-4"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted">
          جاري ربط الملف بالمشروع...
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BButton,
  BSpinner,
  BPagination,
  BFormInput,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BModal,
  BAlert,
  BBadge,
  BFormRadio,
  BFormRadioGroup,
  VBTooltip,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import geodesiaApi from '@/api/geodesia/geodesia'
import SurveyMethods from '@/api/survey-methods/surveyMethods'
import Projects from '@/api/projects/projects'

const surveyMethodsApi = new SurveyMethods()
const projectsApi = new Projects()

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    BSpinner,
    BPagination,
    BFormInput,
    BFormFile,
    BFormGroup,
    BModal,
    BAlert,
    BBadge,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    vSelect,
    FeatherIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      governorates: 'governorates/governorates',
      centers: 'centers/centers',
    }),
    allSelected() {
      return this.projects.length > 0 && this.selectedProjects.length === this.projects.length
    },
    indeterminate() {
      return this.selectedProjects.length > 0 && this.selectedProjects.length < this.projects.length
    },
    bulkLocationJxlTooltip() {
      return 'يُنشئ ملف ZIP (ملخص Excel + ملفات JXL لكل مشروع مؤهل في الفرع الحالي عبر ترويسة الفرع). يُشمل المشروع إذا لم يُربط بملف JXL، وكل سجلات الجيوديسيا مرفوضة أو غير موجودة، ووُجدت إحداثيات مواقع صالحة بعد الدمج. تُستبعد المشاريع التي لا تُنتج إحداثيات.'
    },
    geodesiaSheetTableRows() {
      const rows = this.geodesiaSheetImportResult?.coordinates
      if (!Array.isArray(rows)) return []
      return rows.map(row => ({
        point_name: row.point_name != null ? String(row.point_name) : (row.id != null ? String(row.id) : ''),
        latitude: row.latitude,
        longitude: row.longitude,
        elevation: row.elevation,
        utm_east: row.utm_east,
        utm_north: row.utm_north,
        utm_zone: row.utm_zone != null ? String(row.utm_zone) : '',
      }))
    },
  },
  data() {
    return {
      projects: [],
      selectedProjects: [],
      selectedRows: [],
      loading: false,
      downloading: false,
      downloadingBulkLocationJxl: false,
      showLocationSurveyExportModal: false,
      exportingLocationSurvey: false,
      locationSurveyExportError: null,
      locationSurveyExportErrors: {},
      locationSurveyExportParams: {
        format: 'both',
        governorate_id: null,
        center_id: null,
      },
      locationSurveyExportFormatOptions: [
        { value: 'jxl', text: 'ملف JXL فقط' },
        { value: 'html', text: 'تقرير HTML فقط' },
        { value: 'both', text: 'JXL + HTML' },
      ],
      error: null,
      pagination: null,
      showKmzImportModal: false,
      kmzFile: null,
      importingKmz: false,
      kmzImportError: null,
      kmzImportResult: null,
      showGeodesiaSheetImportModal: false,
      geodesiaSheetFile: null,
      geodesiaSheetProjectId: null,
      importingGeodesiaSheet: false,
      geodesiaSheetImportError: null,
      geodesiaSheetImportResult: null,
      geodesiaSheetTableFields: [
        { key: 'point_name', label: 'النقطة' },
        { key: 'latitude', label: 'خط العرض' },
        { key: 'longitude', label: 'خط الطول' },
        { key: 'elevation', label: 'المنسوب (م)' },
        { key: 'utm_east', label: 'شرق UTM (م)' },
        { key: 'utm_north', label: 'شمال UTM (م)' },
        { key: 'utm_zone', label: 'منطقة UTM' },
      ],
      showRawImportModal: false,
      rawFile: null,
      importingRaw: false,
      rawImportError: null,
      rawImportResult: null,
      showJxlImportModal: false,
      jxlFile: null,
      jxlProjectId: null,
      importingJxl: false,
      jxlImportError: null,
      jxlImportResult: null,
      showDeleteJxlModal: false,
      deleteJxlCoordinateId: null,
      deletingJxlFile: false,
      deleteJxlError: null,
      showJxlStorageModal: false,
      storageDirectory: '',
      storageFiles: [],
      loadingStorageFiles: false,
      storageError: null,
      processingJxlFiles: false,
      processingResult: null,
      showAssignJxlModal: false,
      assignSurveyCoding: '',
      assignJxlFileId: null,
      assignJxlCoordinateId: null,
      assigningJxl: false,
      assignJxlError: null,
      assignJxlResult: null,
      showDownloadModal: false,
      downloadParams: {
        file_extension: '.jxl',
        project_status: null,
        governorate_id: null,
        center_id: null,
        survey_method_id: null,
      },
      downloadingFiles: false,
      downloadError: null,
      surveyMethods: [],
      loadingSurveyMethods: false,
      storageFilesFields: [
        { key: 'file_name', label: 'اسم الملف' },
        { key: 'file_path', label: 'مسار الملف' },
        { key: 'size', label: 'الحجم' },
        { key: 'last_modified', label: 'آخر تعديل' },
      ],
      filters: {
        search: '',
        surveying_code: '',
        owner_name: '',
        governorate_id: null,
        center_id: null,
        check_status: null,
        survey_status: null,
        file_extension: null,
        sort_by: 'created_at',
        sort_order: 'desc',
        per_page: 15,
        page: 1,
      },
      fields: [
        { key: 'selected', label: '', thStyle: { width: '40px' } },
        { key: 'survey_coding', label: 'كود الرفع المساحي', sortable: true },
        { key: 'owners', label: 'الملاك' },
        { key: 'governorate', label: 'المحافظة' },
        { key: 'center', label: 'الجهاز / الحي / المركز' },
        { key: 'check_status', label: 'حالة المراجعة' },
        { key: 'survey_status', label: 'حالة الرفع المساحي' },
        { key: 'file_extension', label: 'نوع الملف' },
      ],
      checkStatusOptions: [
        { value: 'pending', label: 'قيد المراجعة' },
        { value: 'approved', label: 'موافق عليه' },
        { value: 'rejected', label: 'مرفوض' },
      ],
      surveyStatusOptions: [
        { value: 'pending', label: 'قيد التنفيذ' },
        { value: 'completed', label: 'مكتمل' },
        { value: 'in_progress', label: 'جاري التنفيذ' },
      ],
      fileExtensionOptions: [
        { value: '.rw5', label: '.rw5' },
        { value: '.raw', label: '.raw' },
        { value: 'none', label: 'لا يوجد ملف' },
      ],
      downloadFileExtensionOptions: [
        { value: '.jxl', label: 'ملفات JXL (.jxl)' },
        { value: '.rw5', label: 'ملفات RW5 (.rw5)' },
      ],
      downloadProjectStatusOptions: [
        { value: 'planning', label: 'قيد التخطيط' },
        { value: 'active', label: 'نشط' },
        { value: 'on_hold', label: 'متوقف' },
        { value: 'completed', label: 'مكتمل' },
        { value: 'cancelled', label: 'ملغي' },
      ],
      sortByOptions: [
        { value: 'created_at', label: 'تاريخ الإنشاء' },
        { value: 'surveying_code', label: 'كود الرفع المساحي' },
        { value: 'name', label: 'الاسم' },
      ],
      sortOrderOptions: [
        { value: 'asc', label: 'تصاعدي' },
        { value: 'desc', label: 'تنازلي' },
      ],
    }
  },
  mounted() {
    this.fetchProjects()
    this.$store.dispatch('governorates/list', {})
    this.$store.dispatch('centers/list', { governorate_id: this.filters.governorate_id })
  },
  watch: {
    'downloadParams.governorate_id'(newGovernorateId) {
      this.downloadParams.center_id = null
      this.$store.dispatch('centers/list', {
        governorate_id: newGovernorateId || null,
      })
    },
    'locationSurveyExportParams.governorate_id'(newGovernorateId) {
      this.locationSurveyExportParams.center_id = null
      this.$store.dispatch('centers/list', {
        governorate_id: newGovernorateId || null,
      })
    },
    showLocationSurveyExportModal(isOpen) {
      if (isOpen) {
        this.$store.dispatch('centers/list', {
          governorate_id: this.locationSurveyExportParams.governorate_id || null,
        })
      }
    },
  },
  methods: {
    isPositiveInt(value) {
      const n = Number(value)
      return Number.isInteger(n) && n > 0
    },
    parseBulkJxlFilename(contentDisposition, fallbackName = '') {
      if (!contentDisposition || typeof contentDisposition !== 'string') return fallbackName
      const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1]).replace(/["']/g, '')
        } catch (e) {
          return utf8Match[1].replace(/["']/g, '')
        }
      }
      const simpleMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
      if (simpleMatch && simpleMatch[1]) {
        return simpleMatch[1].trim()
      }
      return fallbackName
    },
    async parseBulkJxlErrorBlob(data) {
      if (data instanceof Blob) {
        const text = await data.text()
        try {
          return JSON.parse(text)
        } catch (e) {
          return { message: text }
        }
      }
      return data || {}
    },
    bulkJxlErrorMessage(payload) {
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_projects_eligible_for_bulk_jxl: 'لا توجد مشاريع مطابقة أو لا توجد إحداثيات كافية.',
        failed_to_create_zip: detail || 'فشل إنشاء ملف الأرشيف.',
        bulk_jxl_summary_excel_failed: detail || 'فشل إنشاء ملف ملخص Excel.',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تنزيل أرشيف JXL المجمع'
    },
    locationSurveyExportErrorMessage(payload, status) {
      if (status === 403) {
        return 'ليس لديك صلاحية لتصدير ملفات الرفع المساحي'
      }
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_projects_eligible_for_location_survey_export: 'لا توجد مشاريع مطابقة لخيارات التصدير',
        failed_to_create_zip: detail || 'فشل إنشاء ملف الأرشيف.',
        bulk_location_survey_export_summary_excel_failed: detail || 'فشل إنشاء ملف ملخص Excel.',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تنزيل ملفات الرفع المساحي'
    },
    mapLocationSurveyExportFieldErrors(payload) {
      const errors = {}
      const raw = payload?.errors
      if (!raw || typeof raw !== 'object') return errors
      Object.keys(raw).forEach(field => {
        const val = raw[field]
        errors[field] = Array.isArray(val) ? val[0] : val
      })
      return errors
    },
    buildLocationSurveyExportFilename(format) {
      const dateStamp = new Date().toISOString().slice(0, 10).replace(/-/g, '')
      return `location_survey_exports_${format}_${dateStamp}.zip`
    },
    triggerZipBlobDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    async downloadBulkLocationCoordinatesJxl() {
      this.downloadingBulkLocationJxl = true
      try {
        const response = await projectsApi.exportCoordinatesJxlBulk()
        const status = response.status
        const contentType = String(response.headers['content-type'] || '').toLowerCase()
        let { data: body } = response

        if (status !== 200) {
          const payload = await this.parseBulkJxlErrorBlob(body)
          const msg = this.bulkJxlErrorMessage(payload)
          this.$toast.error(msg)
          return
        }

        if (contentType.includes('application/json')) {
          const payload = await this.parseBulkJxlErrorBlob(body)
          this.$toast.error(this.bulkJxlErrorMessage(payload))
          return
        }

        let blob = body
        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/zip' })
        }

        const cd = response.headers['content-disposition'] || response.headers['Content-Disposition'] || ''
        const fromHeader = (this.parseBulkJxlFilename(cd, '') || '').trim()
        const filename = fromHeader || `location_coordinates_jxl_bulk_${Date.now()}.zip`
        this.triggerZipBlobDownload(blob, filename)
        this.$toast.success('تم تنزيل أرشيف JXL المجمع')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseBulkJxlErrorBlob(error.response.data)
        }
        const msg = this.bulkJxlErrorMessage(payload || {})
        this.$toast.error(msg)
      } finally {
        this.downloadingBulkLocationJxl = false
      }
    },
    async fetchProjects() {
      this.loading = true
      this.error = null

      try {
        const params = { ...this.filters }
        // Remove null and empty values
        Object.keys(params).forEach(key => {
          if (params[key] === null || params[key] === '') {
            delete params[key]
          }
        })

        const response = await geodesiaApi.list(params)

        if (response.success) {
          this.projects = response.data || []
          this.pagination = response.meta || null
          // Clear selections when fetching new data
          this.selectedProjects = []
          this.selectedRows = []
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelected()
            }
          })
        } else {
          this.error = response.message || 'حدث خطأ أثناء جلب البيانات'
        }
      } catch (err) {
        console.error('Error fetching geodesia projects:', err)
        this.error = (err.response && err.response.message) || 'حدث خطأ أثناء جلب البيانات'
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      // Debounce search
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.filters.page = 1
        this.fetchProjects()
      }, 500)
    },
    handleFilterChange() {
      this.filters.page = 1
      this.fetchProjects()
    },
    onPageChange(page) {
      this.filters.page = page
      this.fetchProjects()
    },
    onRowSelected(items) {
      this.selectedRows = items
      this.selectedProjects = items.map(item => item.id)
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.selectAllRows()
      } else {
        this.clearSelected()
      }
    },
    selectAllRows() {
      if (this.$refs.table) {
        this.$refs.table.selectAllRows()
      }
    },
    clearSelected() {
      this.selectedProjects = []
      this.selectedRows = []
      if (this.$refs.table) {
        this.$refs.table.clearSelected()
      }
    },
    async downloadFiles() {
      if (this.selectedProjects.length === 0) {
        this.$toast({
          component: 'ToastificationContent',
          props: {
            title: 'تنبيه',
            icon: 'AlertCircleIcon',
            text: 'يرجى اختيار مشروع واحد على الأقل',
            variant: 'warning',
          },
        })
        return
      }

      this.downloading = true
      this.error = null

      try {
        const response = await geodesiaApi.downloadRawFiles(this.selectedProjects)

        // response.data is already a Blob when responseType is 'blob'
        const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: 'application/zip' })

        // Extract filename from Content-Disposition header if available
        let filename = `geodesia_files_${Date.now()}.zip`
        if (response.headers) {
          const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition']
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].trim()
            }
          }
        }

        // Create download link
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        this.$toast.success('تم تحميل الملفات بنجاح')
        this.selectedProjects = []
        this.selectedRows = []
        if (this.$refs.table) {
          this.$refs.table.clearSelected()
        }
      } catch (err) {
        console.error('Download error:', err)

        // Handle error response (might be blob)
        if (err.response && err.response.data && err.response.data instanceof Blob) {
          try {
            const text = await err.response.text()
            const errorData = JSON.parse(text)
            this.error = errorData.message || 'فشل تحميل الملفات'
            this.$toast.error(errorData.message || 'فشل تحميل الملفات')
          } catch {
            this.error = 'فشل تحميل الملفات'
            this.$toast.error('فشل تحميل الملفات')
          }
        } else {
          const errorMessage = (err.response && err.response.data && err.response.data.message) || 'فشل تحميل الملفات'
          this.error = errorMessage
          this.$toast.error(errorMessage)
        }
      } finally {
        this.downloading = false
      }
    },
    onGovernorateSearch(search, loading) {
      if (search) {
        loading(true)
        const params = { search }
        this.$store.dispatch('governorates/list', params).finally(() => {
          loading(false)
        })
      }
    },
    onCenterSearch(search, loading) {
      if (search) {
        loading(true)
        let governorateId = this.filters.governorate_id
        if (this.showLocationSurveyExportModal) {
          governorateId = this.locationSurveyExportParams.governorate_id
        } else if (this.showDownloadModal) {
          governorateId = this.downloadParams.governorate_id
        }
        const params = { search, governorate_id: governorateId }
        this.$store.dispatch('centers/list', params).finally(() => {
          loading(false)
        })
      }
    },
    getCheckStatusLabel(status) {
      const labels = {
        pending: 'قيد المراجعة',
        approved: 'موافق عليه',
        rejected: 'مرفوض',
      }
      return labels[status] || status
    },
    getCheckStatusVariant(status) {
      const variants = {
        pending: 'warning',
        approved: 'success',
        rejected: 'danger',
      }
      return variants[status] || 'secondary'
    },
    getSurveyStatusLabel(status) {
      const labels = {
        pending: 'قيد التنفيذ',
        completed: 'مكتمل',
        in_progress: 'جاري التنفيذ',
      }
      return labels[status] || status
    },
    getSurveyStatusVariant(status) {
      const variants = {
        pending: 'warning',
        completed: 'success',
        in_progress: 'info',
      }
      return variants[status] || 'secondary'
    },
    onKmzFileChange(event) {
      const file = event.target.files ? event.target.files[0] : null
      if (file) {
        // Validate file extension
        const fileName = file.name.toLowerCase()
        if (!fileName.endsWith('.kmz') && !fileName.endsWith('.kml')) {
          this.kmzImportError = 'يجب أن يكون الملف من نوع .kmz أو .kml'
          this.kmzFile = null
          return
        }
        this.kmzImportError = null
        this.kmzImportResult = null
      }
    },
    async handleKmzImport() {
      if (!this.kmzFile) return

      this.importingKmz = true
      this.kmzImportError = null
      this.kmzImportResult = null

      try {
        const response = await geodesiaApi.importKmzFile(this.kmzFile)

        if (response.data && response.data.status === 'success') {
          this.kmzImportResult = response.data.data
          this.$toast.success(`تم استيراد ${response.data.data.stored_points_count} نقطة بنجاح`)

          // Refresh projects list after successful import
          this.fetchProjects()
        } else {
          this.kmzImportError = (response.data && response.data.message) || 'فشل استيراد الملف'
        }
      } catch (err) {
        console.error('Error importing KMZ file:', err)

        if (err.response && err.response.data) {
          const errorData = err.response.data
          if (errorData.errors && errorData.errors.kmz_file) {
            this.kmzImportError = Array.isArray(errorData.errors.kmz_file)
              ? errorData.errors.kmz_file.join(', ')
              : errorData.errors.kmz_file
          } else {
            this.kmzImportError = errorData.message || 'فشل استيراد الملف'
          }
        } else {
          this.kmzImportError = 'حدث خطأ أثناء استيراد الملف'
        }
      } finally {
        this.importingKmz = false
      }
    },
    resetKmzImport() {
      this.kmzFile = null
      this.kmzImportError = null
      this.kmzImportResult = null
      this.importingKmz = false
      // Reset file input
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"]')
        if (fileInput) {
          fileInput.value = ''
        }
      })
    },
    geodesiaSheetMessageKeyToText(key) {
      const map = {
        no_points_found_in_geodesia_sheet: 'تمت قراءة الورقة ولم يُعثر على صفوف شرق/شمال صالحة.',
        failed_to_read_file_content: 'تعذر قراءة الملف أو الملف فارغ.',
        failed_to_import_geodesia_sheet_file: 'فشل استيراد ملف الجدول على الخادم.',
      }
      return map[key] || null
    },
    formatGeodesiaSheetPointError(rowErr) {
      if (rowErr == null) return ''
      if (typeof rowErr === 'string') return rowErr
      if (typeof rowErr === 'object') {
        const label = rowErr.point_name != null ? rowErr.point_name : rowErr.id
        const body = rowErr.message || rowErr.error || rowErr.reason
        if (label != null && body) return `${label}: ${body}`
        if (body) return String(body)
        try {
          return JSON.stringify(rowErr)
        } catch (e) {
          return String(rowErr)
        }
      }
      return String(rowErr)
    },
    resolveGeodesiaSheetImportHttpError(err) {
      const errorData = err?.response?.data
      const fieldErr = errorData?.errors?.geodesia_sheet_file
      if (fieldErr) {
        return Array.isArray(fieldErr) ? fieldErr[0] : fieldErr
      }
      const msg = typeof errorData?.message === 'string' ? errorData.message.trim() : ''
      if (msg) {
        const mapped = this.geodesiaSheetMessageKeyToText(msg)
        if (mapped) return mapped
        return msg
      }
      return 'حدث خطأ أثناء استيراد الملف'
    },
    onGeodesiaSheetFileInput(file) {
      this.geodesiaSheetImportError = null
      this.geodesiaSheetImportResult = null
      if (!file || !file.name) return
      const lower = file.name.toLowerCase()
      if (!lower.endsWith('.xlsx') && !lower.endsWith('.xls')) {
        this.geodesiaSheetImportError = 'يجب اختيار ملف بصيغة .xlsx أو .xls'
        this.$nextTick(() => {
          this.geodesiaSheetFile = null
        })
      }
    },
    resetGeodesiaSheetImport() {
      this.geodesiaSheetFile = null
      this.geodesiaSheetProjectId = null
      this.geodesiaSheetImportError = null
      this.geodesiaSheetImportResult = null
      this.importingGeodesiaSheet = false
    },
    async submitGeodesiaSheetImport() {
      if (!this.geodesiaSheetFile) return
      const lower = this.geodesiaSheetFile.name.toLowerCase()
      if (!lower.endsWith('.xlsx') && !lower.endsWith('.xls')) {
        this.geodesiaSheetImportError = 'يجب اختيار ملف بصيغة .xlsx أو .xls'
        return
      }
      const projectId = this.geodesiaSheetProjectId != null && this.geodesiaSheetProjectId !== ''
        && Number.isFinite(Number(this.geodesiaSheetProjectId)) && Number(this.geodesiaSheetProjectId) > 0
        ? Number(this.geodesiaSheetProjectId)
        : null

      this.importingGeodesiaSheet = true
      this.geodesiaSheetImportError = null
      this.geodesiaSheetImportResult = null

      try {
        const response = await geodesiaApi.importGeodesiaSheetFile(this.geodesiaSheetFile, projectId)
        if (response && response.success) {
          const data = response.data || {}
          this.geodesiaSheetImportResult = data
          const errCount = Number(data.errors_count || 0)
          if (errCount > 0) {
            this.$toast.warning(`تم الاستيراد مع ${errCount} خطأ جزئي`)
          } else {
            this.$toast.success(`تم استيراد ${data.stored_points_count} نقطة بنجاح`)
          }
          await this.fetchProjects()
        } else {
          const msg = (response && response.message) || 'فشل استيراد الملف'
          const mapped = this.geodesiaSheetMessageKeyToText(String(msg).trim())
          this.geodesiaSheetImportError = mapped || msg
          this.$toast.error(this.geodesiaSheetImportError)
        }
      } catch (err) {
        console.error('Error importing Geodesia sheet:', err)
        this.geodesiaSheetImportError = this.resolveGeodesiaSheetImportHttpError(err)
        this.$toast.error(this.geodesiaSheetImportError)
      } finally {
        this.importingGeodesiaSheet = false
      }
    },
    onRawFileChange(event) {
      const file = event.target.files ? event.target.files[0] : null
      if (file) {
        // Validate file extension
        const fileName = file.name.toLowerCase()
        if (!fileName.endsWith('.raw') && !fileName.endsWith('.rw5')) {
          this.rawImportError = 'يجب أن يكون الملف من نوع .raw أو .rw5'
          this.rawFile = null
          return
        }
        this.rawImportError = null
        this.rawImportResult = null
      }
    },
    async handleRawImport() {
      if (!this.rawFile) return

      this.importingRaw = true
      this.rawImportError = null
      this.rawImportResult = null

      try {
        const response = await geodesiaApi.importRawOrRw5File(this.rawFile)

        if (response && response.success) {
          this.rawImportResult = response.data
          this.$toast.success(`تم استيراد وتحويل ${response.data.points_count} نقطة بنجاح`)

          // Refresh projects list after successful import
          await this.fetchProjects()

          // Close modal after successful import
        } else {
          this.rawImportError = (response && response.message) || 'فشل استيراد وتحويل الملف'
          this.$toast.error(this.rawImportError)
        }
      } catch (err) {
        console.error('Error importing RAW/RW5 file:', err)

        if (err.response && err.response.data) {
          const errorData = err.response.data
          if (errorData.errors && errorData.errors.raw_file) {
            this.rawImportError = Array.isArray(errorData.errors.raw_file)
              ? errorData.errors.raw_file.join(', ')
              : errorData.errors.raw_file
          } else {
            this.rawImportError = errorData.message || 'فشل استيراد وتحويل الملف'
          }
        } else {
          this.rawImportError = 'حدث خطأ أثناء استيراد وتحويل الملف'
        }

        this.$toast.error(this.rawImportError)
      } finally {
        this.importingRaw = false
      }
    },
    resetRawImport() {
      this.rawFile = null
      this.rawImportError = null
      this.rawImportResult = null
      this.importingRaw = false
      // Reset file input
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"][accept*=".raw"]')
        if (fileInput) {
          fileInput.value = ''
        }
      })
    },
    onJxlFileChange(event) {
      const file = event.target.files ? event.target.files[0] : null
      if (file) {
        const fileName = file.name.toLowerCase()
        if (!fileName.endsWith('.jxl')) {
          this.jxlImportError = 'يجب أن يكون الملف من نوع .jxl'
          this.jxlFile = null
          return
        }
        this.jxlImportError = null
        this.jxlImportResult = null
      }
    },
    async handleJxlImport() {
      if (!this.jxlFile) return

      this.importingJxl = true
      this.jxlImportError = null
      this.jxlImportResult = null

      try {
        const response = await geodesiaApi.importJxlFile(this.jxlFile, this.jxlProjectId)

        // Check if response.data exists (axios wraps response in data)
        const responseData = response

        if (responseData && responseData.success) {
          this.jxlImportResult = responseData.data
          this.$toast.success(`تم استيراد ${responseData.data.stored_points_count} نقطة بنجاح`)
          // Refresh the list after successful import
          await this.fetchProjects()
          // Close modal after successful import
          this.$nextTick(() => {
            this.showJxlImportModal = false
          })
        } else {
          // Handle error response structure
          let errorMessage = 'فشل استيراد الملف'

          if (responseData) {
            // Check for errors.jxl_file array first
            if (responseData.errors && responseData.errors.jxl_file && Array.isArray(responseData.errors.jxl_file)) {
              errorMessage = responseData.errors.jxl_file[0]
            } else if (responseData.message) {
              errorMessage = responseData.message
            }
          }

          this.jxlImportError = errorMessage
          this.$toast.error(errorMessage)
        }
      } catch (err) {
        console.error('Error importing JXL file:', err)
        const errorData = (err.response && err.response.data) || err.response

        // Handle error response structure
        let errorMessage = 'حدث خطأ أثناء استيراد الملف'

        if (errorData) {
          // Check for errors.jxl_file array first
          if (errorData.errors && errorData.errors.jxl_file && Array.isArray(errorData.errors.jxl_file)) {
            errorMessage = errorData.errors.jxl_file[0]
          } else if (errorData.message) {
            errorMessage = errorData.message
          }
        }

        this.jxlImportError = errorMessage
        this.$toast.error(errorMessage)
      } finally {
        this.importingJxl = false
      }
    },
    async handleDeleteJxlFile() {
      const id = this.deleteJxlCoordinateId
      if (!this.isPositiveInt(id)) {
        this.deleteJxlError = 'يرجى إدخال معرف إحداثي صالح (رقم صحيح موجب)'
        this.$toast.error(this.deleteJxlError)
        return
      }

      if (!geodesiaApi || typeof geodesiaApi.deleteJxlFile !== 'function') {
        this.deleteJxlError = 'واجهة حذف JXL غير متاحة'
        this.$toast.error(this.deleteJxlError)
        return
      }

      this.deletingJxlFile = true
      this.deleteJxlError = null

      try {
        const response = await geodesiaApi.deleteJxlFile(Number(id))

        if (response && response.success) {
          this.$toast.success(response.message || 'تم حذف ملف JXL بنجاح')
          this.$nextTick(() => {
            this.showDeleteJxlModal = false
          })
          this.fetchProjects()
        } else {
          this.deleteJxlError = (response && response.message) || 'فشل حذف ملف JXL'
          this.$toast.error(this.deleteJxlError)
        }
      } catch (err) {
        console.error('Error deleting JXL file:', err)
        const errorData = err.response && err.response.data ? err.response.data : err.response

        let errorMessage = 'حدث خطأ أثناء حذف ملف JXL'
        if (errorData) {
          if (errorData.errors) {
            const keys = Object.keys(errorData.errors)
            if (keys.length > 0) {
              const first = errorData.errors[keys[0]]
              errorMessage = Array.isArray(first) ? first[0] : first
            }
          } else if (errorData.message) {
            errorMessage = errorData.message
          }
        }
        this.deleteJxlError = errorMessage
        this.$toast.error(errorMessage)
      } finally {
        this.deletingJxlFile = false
      }
    },
    resetDeleteJxlModal() {
      this.deleteJxlCoordinateId = null
      this.deleteJxlError = null
      this.deletingJxlFile = false
    },
    resetJxlImport() {
      this.jxlFile = null
      this.jxlProjectId = null
      this.jxlImportError = null
      this.jxlImportResult = null
      this.importingJxl = false
      // Reset file input
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"]')
        if (fileInput) {
          fileInput.value = ''
        }
      })
    },
    downloadProjectsFilesErrorMessage(payload = {}, err = null) {
      const isNetworkError = !err?.response && (
        err?.message === 'Network Error'
        || err?.code === 'ERR_NETWORK'
        || /network error/i.test(err?.message || '')
      )
      if (isNetworkError) {
        return 'تعذر استكمال تحميل الملف. غالباً انقطع الاتصال أثناء إنشاء الأرشيف (حجم كبير أو مهلة السيرفر) أو حظر المتصفح الاستجابة. جرّب تضييق الفلاتر ثم أعد المحاولة.'
      }

      const code = payload?.code || payload?.message
      const map = {
        no_projects_found: 'لم يتم العثور على مشاريع تطابق المعايير المحددة',
        no_files_added_to_zip: 'لم يتم العثور على ملفات للتحميل',
        failed_to_create_zip: 'فشل إنشاء ملف ZIP. يرجى المحاولة مرة أخرى',
        failed_to_download_files: 'فشل تحميل الملفات. يرجى المحاولة مرة أخرى',
        empty_download: 'لم يتم استلام بيانات الملف',
      }
      if (code && map[code]) return map[code]

      if (payload?.errors && typeof payload.errors === 'object') {
        const firstError = Object.values(payload.errors)[0]
        return Array.isArray(firstError) ? firstError[0] : firstError
      }
      if (typeof payload?.message === 'string' && payload.message && !map[payload.message]) {
        return payload.message
      }
      if (payload?.error) return payload.error
      return 'حدث خطأ أثناء تحميل الملفات'
    },
    async handleDownloadFiles() {
      if (!this.downloadParams.file_extension) {
        this.$toast.error('يرجى اختيار نوع الملف')
        return
      }

      this.downloadingFiles = true
      this.downloadError = null

      try {
        const params = {
          file_extension: this.downloadParams.file_extension,
        }

        if (this.downloadParams.project_status) {
          params.project_status = this.downloadParams.project_status
        }
        if (this.downloadParams.governorate_id) {
          params.governorate_id = this.downloadParams.governorate_id
        }
        if (this.downloadParams.center_id) {
          params.center_id = this.downloadParams.center_id
        }
        if (this.downloadParams.survey_method_id) {
          params.survey_method_id = this.downloadParams.survey_method_id
        }

        const response = await geodesiaApi.downloadProjectsFilesWithCoordinates(params)
        const status = response.status
        const contentType = String(
          (response.headers && (response.headers['content-type'] || response.headers['Content-Type'])) || '',
        ).toLowerCase()
        let { data: body } = response

        if (status !== 200) {
          const payload = await this.parseBulkJxlErrorBlob(body)
          const errorMessage = this.downloadProjectsFilesErrorMessage(payload)
          this.downloadError = errorMessage
          this.$toast.error(errorMessage)
          return
        }

        if (contentType.includes('application/json')) {
          const payload = await this.parseBulkJxlErrorBlob(body)
          const errorMessage = this.downloadProjectsFilesErrorMessage(payload)
          this.downloadError = errorMessage
          this.$toast.error(errorMessage)
          return
        }

        let blob = body
        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/zip' })
        }

        if (!blob.size) {
          const errorMessage = this.downloadProjectsFilesErrorMessage({ code: 'empty_download' })
          this.downloadError = errorMessage
          this.$toast.error(errorMessage)
          return
        }

        const cd = (response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])) || ''
        const filename = this.parseBulkJxlFilename(cd, 'الحلواني.zip') || 'الحلواني.zip'
        this.triggerZipBlobDownload(blob, filename)
        this.$toast.success('تم تحميل الملفات بنجاح')
      } catch (err) {
        console.error('Error downloading files:', err)

        let payload = {}
        if (err.response && err.response.data) {
          payload = await this.parseBulkJxlErrorBlob(err.response.data)
        }

        const errorMessage = this.downloadProjectsFilesErrorMessage(payload, err)
        this.downloadError = errorMessage
        this.$toast.error(errorMessage)
      } finally {
        this.downloadingFiles = false
      }
    },
    resetDownloadModal() {
      this.downloadParams = {
        file_extension: '.jxl',
        project_status: null,
        governorate_id: null,
        center_id: null,
        survey_method_id: null,
      }
      this.downloadError = null
      this.downloadingFiles = false
    },
    resetLocationSurveyExportModal() {
      this.locationSurveyExportParams = {
        format: 'both',
        governorate_id: null,
        center_id: null,
      }
      this.locationSurveyExportErrors = {}
      this.locationSurveyExportError = null
      this.exportingLocationSurvey = false
    },
    async exportLocationSurveyFiles() {
      const { format, governorate_id: governorateId, center_id: centerId } = this.locationSurveyExportParams
      if (!format) return

      this.exportingLocationSurvey = true
      this.locationSurveyExportError = null
      this.locationSurveyExportErrors = {}

      const params = { format }
      if (governorateId) params.governorate_id = governorateId
      if (centerId) params.center_id = centerId

      try {
        const response = await projectsApi.exportLocationSurveyExportsBulk(params)
        const status = response.status
        const contentType = String(response.headers['content-type'] || '').toLowerCase()
        let { data: body } = response

        if (status !== 200) {
          const payload = await this.parseBulkJxlErrorBlob(body)
          if (status === 422) {
            this.locationSurveyExportErrors = this.mapLocationSurveyExportFieldErrors(payload)
          }
          const msg = this.locationSurveyExportErrorMessage(payload, status)
          this.locationSurveyExportError = msg
          this.$toast.error(msg)
          return
        }

        if (contentType.includes('application/json')) {
          const payload = await this.parseBulkJxlErrorBlob(body)
          const msg = this.locationSurveyExportErrorMessage(payload, status)
          this.locationSurveyExportError = msg
          this.$toast.error(msg)
          return
        }

        let blob = body
        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/zip' })
        }

        const cd = response.headers['content-disposition'] || response.headers['Content-Disposition'] || ''
        const fromHeader = (this.parseBulkJxlFilename(cd, '') || '').trim()
        const filename = fromHeader || this.buildLocationSurveyExportFilename(format)
        this.triggerZipBlobDownload(blob, filename)
        this.$toast.success('تم تنزيل أرشيف ملفات الرفع المساحي')
        this.showLocationSurveyExportModal = false
      } catch (error) {
        let payload = error.payload
        const status = error.response && error.response.status
        if (!payload && error.response && error.response.data) {
          payload = await this.parseBulkJxlErrorBlob(error.response.data)
        }
        if (status === 422 && payload) {
          this.locationSurveyExportErrors = this.mapLocationSurveyExportFieldErrors(payload)
        }
        const msg = this.locationSurveyExportErrorMessage(payload || {}, status)
        this.locationSurveyExportError = msg
        this.$toast.error(msg)
      } finally {
        this.exportingLocationSurvey = false
      }
    },
    async fetchSurveyMethods() {
      if (this.surveyMethods.length > 0 || this.loadingSurveyMethods) {
        return // Already loaded or loading
      }

      this.loadingSurveyMethods = true
      try {
        const response = await surveyMethodsApi.list()
        if (response.data && Array.isArray(response.data)) {
          // Sort by order if available
          this.surveyMethods = response.data.sort((a, b) => {
            const orderA = a.order || 0
            const orderB = b.order || 0
            return orderA - orderB
          })
        } else {
          this.surveyMethods = []
        }
      } catch (error) {
        console.error('Failed to fetch survey methods:', error)
        this.surveyMethods = []
      } finally {
        this.loadingSurveyMethods = false
      }
    },
    async fetchStorageFiles() {
      this.loadingStorageFiles = true
      this.storageError = null
      this.storageFiles = []

      try {
        const directory = this.storageDirectory.trim() || null
        const response = await geodesiaApi.getJxlFilesFromStorage(directory)

        if (response.success) {
          this.storageFiles = response.data.files || []
          if (this.storageFiles.length === 0) {
            this.storageError = 'لم يتم العثور على ملفات JXL في المجلد المحدد'
          }
        } else {
          this.storageError = response.message || 'فشل جلب الملفات من التخزين'
        }
      } catch (err) {
        console.error('Error fetching storage files:', err)
        const errorData = err.response && err.response.data ? err.response.data : err.response
        this.storageError = (errorData && errorData.message) || 'حدث خطأ أثناء جلب الملفات من التخزين'
      } finally {
        this.loadingStorageFiles = false
      }
    },
    async handleProcessJxlFiles() {
      if (this.storageFiles.length === 0) {
        this.$toast.error('لا توجد ملفات للمعالجة')
        return
      }

      this.processingJxlFiles = true
      this.processingResult = null
      this.storageError = null

      try {
        const directory = this.storageDirectory.trim() || null
        const response = await geodesiaApi.processJxlFilesFromStorage(directory, null)

        if (response.success) {
          this.processingResult = response.data
          this.$toast.success(`تم معالجة ${response.data.processed_files_count} ملف بنجاح`)
          // Refresh projects list after processing
          await this.fetchProjects()
          // Refresh storage files list
          await this.fetchStorageFiles()
        } else {
          this.storageError = response.message || 'فشل معالجة الملفات'
          this.$toast.error(this.storageError)
        }
      } catch (err) {
        console.error('Error processing JXL files:', err)
        const errorData = err.response && err.response.data ? err.response.data : err.response
        this.storageError = (errorData && errorData.message) || 'حدث خطأ أثناء معالجة الملفات'
        this.$toast.error(this.storageError)
      } finally {
        this.processingJxlFiles = false
      }
    },
    resetJxlStorage() {
      this.storageDirectory = ''
      this.storageFiles = []
      this.storageError = null
      this.processingResult = null
      this.processingJxlFiles = false
      this.loadingStorageFiles = false
    },
    async handleAssignJxl() {
      if (!this.assignSurveyCoding || !this.assignJxlCoordinateId) {
        this.$toast.error('يرجى إدخال كود الرفع المساحي ومعرف الإحداثي')
        return
      }

      // Check if API method exists
      if (!geodesiaApi || typeof geodesiaApi.assignJxlToProjectBySurveyCoding !== 'function') {
        console.error('geodesiaApi.assignJxlToProjectBySurveyCoding is not available')
        this.$toast.error('خطأ في تحميل واجهة برمجة التطبيقات. يرجى تحديث الصفحة')
        return
      }

      this.assigningJxl = true
      this.assignJxlError = null
      this.assignJxlResult = null

      try {
        const response = await geodesiaApi.assignJxlToProjectBySurveyCoding(
          this.assignSurveyCoding,
          this.assignJxlCoordinateId,
        )

        if (response.success) {
          this.assignJxlResult = response.data
          this.$toast.success('تم ربط الملف بالمشروع بنجاح')
          // Refresh projects list
          await this.fetchProjects()
          // Close modal after a delay to show success message
          setTimeout(() => {
            this.showAssignJxlModal = false
          }, 2000)
        } else {
          this.assignJxlError = response.message || 'فشل ربط الملف بالمشروع'
          this.$toast.error(this.assignJxlError)
        }
      } catch (err) {
        console.error('Error assigning JXL file:', err)
        const errorData = err.response && err.response.data ? err.response.data : err.response

        let errorMessage = 'حدث خطأ أثناء ربط الملف بالمشروع'

        if (errorData) {
          if (errorData.errors) {
            // Handle validation errors
            const errorKeys = Object.keys(errorData.errors)
            if (errorKeys.length > 0) {
              errorMessage = Array.isArray(errorData.errors[errorKeys[0]])
                ? errorData.errors[errorKeys[0]][0]
                : errorData.errors[errorKeys[0]]
            }
          } else if (errorData.message) {
            errorMessage = errorData.message
          }
        }

        this.assignJxlError = errorMessage
        this.$toast.error(errorMessage)
      } finally {
        this.assigningJxl = false
      }
    },
    resetAssignJxl() {
      this.assignSurveyCoding = ''
      this.assignJxlFileId = null
      this.assignJxlCoordinateId = null
      this.assignJxlError = null
      this.assignJxlResult = null
      this.assigningJxl = false
    },
    formatFileSize(bytes) {
      if (!bytes) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${Math.round(bytes / Math.pow(k, i) * 100) / 100} ${sizes[i]}`
    },
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('ar-EG')
    },
  },
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 1rem;
}

.geodesia-sheet-import-table-wrap {
  max-height: 320px;
  overflow: auto;
}
</style>
